import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  FileRegistrationResultRequestBody,
  FileRegistrationResultResponse,
} from "./types";

export class FileRegistrationResultJson extends BaseAPI<
  FileRegistrationResultRequestBody,
  FileRegistrationResultResponse
> {
  protected route = ApiRoutes.file.registration_results;
  protected method = RequestMethod.GET;
}
